import couponsApi from '~referral/api/coupons';

const ACTION_PREFIX = 'referral/coupons';

const APPLICATION_INFO_INIT = `${ACTION_PREFIX}/APPLICATION_INFO_INIT`;
const APPLICATION_INFO_DONE = `${ACTION_PREFIX}/APPLICATION_INFO_DONE`;
const APPLICATION_INFO_ERROR = `${ACTION_PREFIX}/APPLICATION_INFO_ERROR`;
const UPDATE_APPLIED_COUPON = `${ACTION_PREFIX}/UPDATE_APPLIED_COUPON`;
const TOGGLE_COUPON_MODAL = `${ACTION_PREFIX}/TOGGLE_COUPON_MODAL`;

export function updateAppliedReferralCoupon(couponCode) {
  return {
    type: UPDATE_APPLIED_COUPON,
    payload: couponCode,
  };
}

export function toggleCouponModal(isModalOpen) {
  return {
    type: TOGGLE_COUPON_MODAL,
    payload: isModalOpen,
  };
}

export function loadCouponApplicationInfo() {
  return async (dispatch, getData) => {
    const { isLoading, isSuccess } = getData().referral.coupons;

    if (isLoading || isSuccess) return;

    dispatch({
      type: APPLICATION_INFO_INIT,
    });
    try {
      const json = await couponsApi.applicationInfo();
      dispatch({
        type: APPLICATION_INFO_DONE,
        payload: json,
      });
    } catch (error) {
      dispatch({
        type: APPLICATION_INFO_ERROR,
        error,
      });
    }
  };
}

const initialState = {
  previousAppliedCoupon: null,
  paymentDone: false,
  isLoading: false,
  isSuccess: false,
  isModalOpen: false,
  error: null,
};

export default function userReducer(
  state = initialState, action,
) {
  switch (action.type) {
    case APPLICATION_INFO_INIT:
      return {
        ...state,
        isLoading: true,
      };
    case APPLICATION_INFO_ERROR:
      return {
        ...state,
        isLoading: false,
        eligibilityDataError: action.error,
      };
    case APPLICATION_INFO_DONE:
      return {
        ...state,
        previousAppliedCoupon: action.payload.previous_applied_coupon,
        paymentDone: action.payload.payment_done,
        isSuccess: true,
        isLoading: false,
      };
    case UPDATE_APPLIED_COUPON:
      return {
        ...state,
        previousAppliedCoupon: action.payload,
      };
    case TOGGLE_COUPON_MODAL:
      return {
        ...state,
        isModalOpen: action.payload,
      };
    default:
      return state;
  }
}
